import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import {wrapper} from "lib/store";
import Link from "next/link";
import {getServiceCategories} from "lib/services/product";
import ItemGrid from "components/blocks/ItemGrid";
import React, {useEffect} from "react";
import CategoryCard from "components/cards/CategoryCard";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {getPaginatedServicesThunk} from "lib/features/productSlice";

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
  const {
    query,locale, router
  } = context
  const {
    country,
    region,
    city,
    languages,
    latitude, longitude,page = 1,
    locationTypes = [],
    amenities = [],
    openNow = false,
    sort = {},
  } = query
  const filter = {
    latitude: latitude,
    longitude: longitude,
    locationTypes,
    amenities,
    openNow
  }

  const categories = await getServiceCategories()
  return {
    props: {
      categories,
      ...(await serverSideTranslations(locale, ['home', 'common']))
    }
  }
})

const PlainCategory = function (props) {
  const {
    data: category
  } = props

  return (
    <Link href={`/services/listing?categories=${category.slug}`}>
      <a>
        <div>
          {category.name}
        </div>
      </a>
    </Link>
  )
}

export default function Services(props) {
  const {
    categories: _categories
  } = props
  const { t } = useTranslation()

  useEffect(() => {
    // console.log('service categories: ', JSON.stringify(_categories))
  }, [])

  return (
    <Wrapper>
      <Container>
        <ItemGrid
          title={t('home:product_browsebycategory')} items={_categories}
          render={item => (
              <CategoryCard t={t} key={item.slug} cardType={'service'} categoryLevel={1} data={item} baseUrl={`/services/listing?categories=${item.slug}`} />
          )}/>
      </Container>
    </Wrapper>
  )
}

Services.getLayout = function getLayout(page) {
  return (
    <DefaultLayout>
      {page}
    </DefaultLayout>
  )
}
